import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router";
import MultiSelectList from "../questions/metadataDropDownList";
import Constant from "../../../utils/constant";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import Select from "react-select";
import { getContentArea } from "../../../api/contentArea.service";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import DeleteModal from "../../shared/common/deleteModal";
import Loader from "../../shared/loader/loader";
import {
  getGradeAll,
  getStateAll,
  getSubject,
} from "../../../api/subject.service";
import {
  AddIcon,
  FilterIcon,
  EditIcon,
  DeleteIcon,
  ResetIcon,
  ApproveIcon,
  Disapprove,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  CSVIcon,
  CollapseDownIcon,
  CollapseUpIcon,
  CopyIcon,
} from "../../../assets/icons/index";
import { IBundle, IBundleProduct } from "../../../model/interface/bundle";
import {
  deleteBundle,
  deleteBundleProduct,
  getBundle,
  getBundleById,
  copyBundle,
} from "../../../api/bundle.service";
import { IGrade, IState } from "../../../model/interface/domain";
import { IContent } from "../../../model/interface/content";
import { ISubjectPage } from "../../../model/interface/subject";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import ExportToCSV from "../../shared/common/exportToCsv";
import ActiveRowLine from "../../shared/common/activeRowLine";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import MultiStateButton from "../../shared/common/multiStateButton";
import CopyBundleModal from "../../shared/common/copyBundle";
import { connect } from "react-redux";
const activeMultiState = [
  { label: "Active", value: true, selected: true },
  { label: "Both", value: null },
  { label: "Inactive", value: false },
];

const Bundle: React.FC = (props: any) => {
  const gradeLevelData = [
    {
      value: "ece",
      name: "Early Childhood Learning",
      label: "Early Childhood Learning (ece)",
    },
    { value: "elem", name: "Elementary", label: "Elementary (elem)" },
    { value: "ms", name: "Middle School", label: "Middle School (ms)" },
    { value: "hs", name: "High School", label: "High School (hs)" },
  ];
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [isActive, setIsActive] = useState<boolean | undefined>(undefined);
  const [bundles, setBundles] = useState<IBundle[]>([]);
  const [bundleProduct, setBundleProduct] = useState<Array<any>>();
  const [grade, setGrade] = useState<IGrade[]>([]);
  const [state, setState] = useState<IState[]>([]);
  const [content, setContent] = useState<IContent[]>([]);
  const [subjects, setSubjects] = useState<ISubjectPage[]>([]);
  const [selectSubjects, setSelectSubjects] = useState<number>(0);
  const [selectContent, setSelectContent] = useState<number>(0);
  const [selectState, setSelectState] = useState<number>(0);
  const [selectGrade, setSelectGrade] = useState<number>(0);
  const [selectGradeLevel, setSelectGradeLevel] = useState<ISelectElement>();
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [orderByColumn, setOrderByColumn] = useState("name");
  const [bundleName, setBundleName] = useState<string>("");
  const [totalPages, setTotalPages] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [sortByDesc, setSortByDesc] = useState<boolean>(true);
  const [toggle, setToggle] = useState<number>();
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [associateBundle, setAssociateBundle] = useState<any>();
  const navigate = useNavigate();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const childRef: any = useRef(undefined);
  const [notify, setNotify] = useState<any>({
    visible: false,
    title: "",
    message: "",
    icon: false,
  });
  const [bundleId, setBundleId] = useState<number>(0);
  const [isAlaCarte, setIsAlaCarte] = useState<boolean>(false);
  const [showCopyBundlePopup, setShowCopyBundlePopup] =
    useState<boolean>(false);
  const [selectedCopyBundleId, setSelectedCopyBundleId] = useState<number>();
  const [selectedCopyBundleName, setSelectedCopyBundleName] =
    useState<string>("");

  const handleRedirect = (bundle?: IBundle) => {
    navigate(
      bundle
        ? Constant.EDITBUNDLES.replace(":id", bundle.bundleId.toString())
        : Constant.ADDBUNDLES,
      { state: { objectToEdit: bundle?.bundleId } }
    );
  };

  const handleBundleDelete = (bundle) => {
    setShowDeleteModal(true);
    setAssociateBundle(bundle);
  };

  const deleteRecordHandler = async () => {
    setLoading(true);
    const deletebundleItem = {
      bundleId: associateBundle.bundleId,
    };

    await deleteBundle(deletebundleItem);
    getBundleData();
    setShowDeleteModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleBundleProduct = async (id, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const response = getBundleById(id);
      const data = (await response).data;
      if (data?.sellableProducts && data?.sellableProducts.length > 0) {
        data?.sellableProducts.forEach((d) => {
          d.bundleId = id;
        });
      }
      setBundleProduct(data?.sellableProducts);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const handleSortBy = (column: string) => {
    setSortByDesc(!sortByDesc);
    setOrderByColumn(column);
  };

  const handleBundleName = (e) => {
    setBundleName(e.target.value);

    if (e.target.value === "") {
      getBundleData(true);
    }
  };

  const handleBundleId = (e) => {
    setBundleId(e.target.value);

    if (e.target.value === "") {
      getBundleData(true);
    }
  };

  const filterHandler = (e) => {
    e.preventDefault();
    setLoading(true);

    const bundle = {
      bundleId: bundleId,
      bundleName: bundleName,
      orderByColumn: orderByColumn,
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: pageSize,
      pageNumber: pageNumber,
      isActive: isActive,
      subjectId: selectSubjects,
      contentAreaId: selectContent,
      stateId: selectState,
      gradeId: selectGrade,
      gradeLevelId: selectGradeLevel?.value,
      isAlaCarte: isAlaCarte ? isAlaCarte : false,
    };
    getBundle(bundle).then((response) => {
      setBundles(response.data.data);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setTotalRecords(response.data.totalRecords);
      paginationRef?.current?.onReset();
      pageSizeRef?.current?.onReset();
      setLoading(false);
    });
  };

  const handleRedirectBundleProduct = (product: IBundleProduct) => {
    navigate(
      Constant.MANAGESELLABLEPRODUCT.replace(
        ":id",
        product.sellableProductId.toString()
      )
    );
  };

  const handleDeleteBundleProduct = async (product: IBundleProduct) => {
    setLoading(true);
    await deleteBundleProduct(product.bundleId, product.sellableProductId);
    getBundleData();
    setToggle(undefined);
  };

  const getStateData = async () => {
    const response = getStateAll(999, 1);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setState(newStateData);
  };

  const getGradeData = async () => {
    const response = getGradeAll(999, 1);
    const data = (await response).data;
    let newGradeData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );

      newGradeData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrade(newGradeData);
  };

  const getContent = async () => {
    const response = getContentArea(999, 1);
    const data = (await response).data;
    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContent(newContentData);
  };

  const getSubjectData = async () => {
    setLoading(true);
    const params = {
      name: "",
      contentAreaId: selectContent || 0,
      stateId: selectState || 0,
      gradeId: selectGrade || 0,
      gradeLevel: selectGradeLevel?.value || "",
      orderbyColumn: "name",
      sortDir: sortByDesc ? "desc" : "asc",
      pageSize: 999,
      pageNumber: 1,
      isActive: true,
      isApproved: true,
    };

    const response = getSubject(params);
    const data = (await response).data;
    setLoading(false);
    let newSubjectData = [];
    if (data.data.length > 0) {
      newSubjectData = data.data.map((eachSubjectData) => {
        return {
          value: eachSubjectData.subjectId || 0,
          label: `${eachSubjectData.name}`,
        };
      });
    }
    setSubjects(newSubjectData);
  };

  async function getBundleData(isReset?, column?) {
    setLoading(true);
    const bundle = {
      bundleId: isReset ? 0 : bundleId,
      bundleName: isReset ? "" : bundleName,
      orderByColumn: orderByColumn ? orderByColumn : column ? column : "name",
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: isReset ? defaultPageSize : pageSize,
      pageNumber: isReset ? defaultPageNumber : pageNumber,
      isActive: isReset ? undefined : isActive,
      subjectId: isReset ? 0 : selectSubjects,
      contentAreaId: isReset ? 0 : selectContent,
      stateId: isReset ? 0 : selectState,
      gradeId: isReset ? 0 : selectGrade,
      gradeLevelId: isReset ? "" : selectGradeLevel?.value,
      isAlaCarte: isAlaCarte ? isAlaCarte : false,
    };

    getBundle(bundle).then((response) => {
      setBundles(response.data.data);
      setTotalPages(
        Math.ceil(
          response.data.totalRecords / (isReset ? defaultPageSize : pageSize)
        )
      );
      setTotalRecords(response.data.totalRecords);
      setLoading(false);
    });
  }

  useEffect(() => {
    if (isLoaded) {
      getBundleData();
    }
    setToggle(undefined);
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      getSubjectData();
      getGradeData();
      getStateData();
      getContent();
      getBundleData();

      setIsLoaded(true);
    } else {
      paginationRef?.current?.onReset();
    }
    setToggle(undefined);
  }, [pageSize]);

  const resetClickHandler = () => {
    setBundleName("");
    setSelectSubjects(0);
    setSelectContent(0);
    setSelectState(0);
    setSelectGrade(0);
    setSelectGradeLevel({ value: "", label: "" });
    setBundleId(0);
    setResetDropdownFlag(!resetDropdownFlag);
    getBundleData(true);
    setIsActive(undefined);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
  };

  useEffect(() => {
    getSubjectData();
  }, [selectContent, selectState, selectGrade, selectGradeLevel]);

  useEffect(() => {
    if (isLoaded) {
      getBundleData();
    }
  }, [sortByDesc]);

  const updateDropdownValues = (updateObj) => {
    if (updateObj.type == "GradeLevel") {
      setSelectGradeLevel({
        value: updateObj.value || "",
        label: updateObj.label || "",
      });
    }
  };

  const exportFn = async () => {
    setLoading(true);
    const bundle = {
      bundleId: bundleId,
      bundleName: bundleName,
      orderByColumn: orderByColumn,
      sortByDesc: sortByDesc ? "ASC" : "DESC",
      pageSize: 999,
      pageNumber: 1,
      isActive: isActive,
      subjectId: selectSubjects,
      contentAreaId: selectContent,
      stateId: selectState,
      gradeId: selectGrade,
      gradeLevelId: selectGradeLevel?.value,
      isAlaCarte: isAlaCarte,
    };

    const response = getBundle(bundle);
    const data = (await response).data;
    setLoading(false);

    if (data && data.data && data.data.length > 0) {
      childRef?.current?.onDownload(data.data, "bundles.csv");
    } else {
      setNotify({
        visible: true,
        title: "Warning",
        message: "No records to download",
        icon: false,
      });
      setTimeout(() => setNotify({ visible: false }), 1500);
    }
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const input = document.getElementById("bundleId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  function handleCopyBundle(bundleId: number, bundleName: string) {
    setSelectedCopyBundleId(bundleId);
    setSelectedCopyBundleName(bundleName);
    setShowCopyBundlePopup(true);
  }

  function closeCopyBundlePopup() {
    setShowCopyBundlePopup(false);
  }
  function cloneBundle(bundleId: number) {
    setShowCopyBundlePopup(false);

    copyBundle(
      props?.profile?.userId ? props?.profile?.userId : 1,
      bundleId
    ).then((res) => {
      const copiedBundle = res.data;
      navigate(Constant.EDITBUNDLES.replace(":id", copiedBundle.toString()));
    });
  }

  return (
    <AllowedTo perform={Permissions.bundle_view} no={() => <AccessDenied />}>
      {loading && <Loader />}

      {showCopyBundlePopup && (
        <CopyBundleModal
          closeCopyBundleModal={closeCopyBundlePopup}
          cloneBundle={cloneBundle}
          bundleName={selectedCopyBundleName}
          bundleId={selectedCopyBundleId}
        />
      )}

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          deleteRecord={deleteRecordHandler}
        />
      )}
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">Bundle</h3>
              <AllowedTo perform={Permissions.bundle_create}>
                <button
                  type="button"
                  className="inline-flex items-center px-3 py-1 border border-transparent text-sm leading-4 rounded-md shadow-xs text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color hover:shadow-lg transsition ease-in-out duration-300"
                  onClick={() => handleRedirect()}
                >
                  <AddIcon className="w-6"></AddIcon>
                  Add Bundle
                </button>
              </AllowedTo>
            </div>
            <form action="#" onSubmit={filterHandler}>
              <div className="pt-6 border-b pb-6">
                <div className="grid grid-cols-12 gap-6">
                  <div className="col-span-2 sm:col-span-2 ">
                    <label className="text-sm text-gray-700">Bundle Id</label>
                    <div className="contentArea">
                      <input
                        id="bundleId"
                        name="bundleId"
                        type="text"
                        autoComplete="off"
                        value={bundleId || ""}
                        onChange={handleBundleId}
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                  </div>
                  <div className="col-span-2 sm:col-span-2 ">
                    <label className="text-sm text-gray-700">Bundle Name</label>
                    <div className="contentArea">
                      <input
                        id="name"
                        name="name"
                        type="text"
                        autoComplete="off"
                        value={bundleName}
                        onChange={handleBundleName}
                        className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">
                      Content Area
                    </label>
                    <div className="mt-1 text-sm">
                      <MultiSelectList
                        dropValue={content}
                        defaultValue={"Content Area"}
                        value={selectContent}
                        resetDropdown={resetDropdownFlag}
                        dropSelect={setSelectContent}
                        multiple={false}
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">State</label>
                    <div className="mt-1 text-sm">
                      <MultiSelectList
                        dropValue={state}
                        defaultValue={"State"}
                        value={selectState}
                        resetDropdown={resetDropdownFlag}
                        dropSelect={setSelectState}
                        multiple={false}
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade</label>
                    <div className="mt-1 text-sm">
                      <MultiSelectList
                        dropValue={grade}
                        defaultValue={"Grade"}
                        value={selectGrade}
                        resetDropdown={resetDropdownFlag}
                        dropSelect={setSelectGrade}
                        multiple={false}
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Grade Level</label>
                    <div className="mt-1 text-sm">
                      <Select
                        className="mt-1 text-sm"
                        value={{
                          label: selectGradeLevel?.label,
                          value: selectGradeLevel?.value,
                        }}
                        onChange={(result) =>
                          updateDropdownValues({
                            ...result,
                            type: "GradeLevel",
                          })
                        }
                        options={gradeLevelData}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#B3B3B3",
                            primary: "#041E42",
                          },
                        })}
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            background:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#1A1C23"
                                : "white",
                            borderColor:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "#6B7280"
                                : "#D1D5DB",
                            borderWidth: "1px",
                            "&:hover": {
                              borderColor:
                                state.isFocused &&
                                document.getElementsByClassName("dark")
                                  ?.length > 0
                                  ? "#6b7280"
                                  : state.isFocused
                                  ? "#4c5563"
                                  : "",
                            },
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "#374051",
                          }),
                          input: (base) => ({
                            ...base,
                            color:
                              document.getElementsByClassName("dark")?.length >
                              0
                                ? "white"
                                : "",
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-span-2">
                    <label className="text-sm text-gray-700">Subject</label>
                    <div className="mt-1 text-sm">
                      <MultiSelectList
                        dropValue={subjects}
                        defaultValue={"Subject"}
                        value={selectSubjects}
                        resetDropdown={resetDropdownFlag}
                        dropSelect={setSelectSubjects}
                        multiple={false}
                      />
                    </div>
                  </div>
                  <div className="col-span-2 flex items-center mt-6">
                    <MultiStateButton
                      labels={activeMultiState}
                      onSelect={(e) => setIsActive(e.value)}
                      onReset={resetDropdownFlag}
                    />
                  </div>
                  <div className="col-span-1 flex items-end">
                    <div className="flex items-center">
                      <input
                        id="isAlaCarte"
                        name="isAlaCarte"
                        type="checkbox"
                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                        onChange={() => {
                          setIsAlaCarte(!isAlaCarte);
                        }}
                        checked={isAlaCarte}
                      />
                      <label className="ml-1.5 py-2 text-sm text-gray-700">
                        A La Carte
                      </label>
                    </div>
                  </div>
                </div>
                <div className="flex justify-start">
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    onClick={resetClickHandler}
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>
              </div>
              <div className="flex justify-end mb-2">
                <button
                  type="button"
                  onClick={() => exportFn()}
                  className="mt-4 py-1.5 px-4 inline-flex ml-auto items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                >
                  <CSVIcon className="w-3 h-3 dark:text-white stroke-current"></CSVIcon>
                  <span>Export</span>
                </button>
                <ExportToCSV ref={childRef} />
              </div>
            </form>
            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="inline-flex items-center gap-2 px-5 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {sortByDesc &&
                                  orderByColumn === "bundleId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("bundleId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("bundleId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Name
                                <span className="cursor-pointer">
                                  {!sortByDesc && orderByColumn === "name" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSortBy("name")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="w-96 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              State
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              A La Carte
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              <span className="flex gap-2">
                                Salesforce Level
                                <span className="cursor-pointer">
                                  {!sortByDesc &&
                                  orderByColumn === "SalesforceLevel" ? (
                                    <CaretUpSolidIcon
                                      onClick={() =>
                                        handleSortBy("SalesforceLevel")
                                      }
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() =>
                                        handleSortBy("SalesforceLevel")
                                      }
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="inline-flex items-center gap-2 px-3 py-2 font-light text-sm text-left text-white dark:text-white tracking-wider"
                            >
                              Products Count
                            </th>

                            <th
                              scope="col"
                              className="w-10 px-3 py-2 font-light text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {bundles.map((bundle, index) => (
                            <Disclosure key={index}>
                              {() => (
                                <>
                                  <tr
                                    key={index}
                                    className={
                                      index % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }
                                  >
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500 relative">
                                      <ActiveRowLine
                                        isActive={bundle.isActive}
                                      />
                                      <div className="flex ...">
                                        <div className="mt-2">
                                          {bundle?.totalProducts > 0 ? (
                                            <DisclosureButton className="">
                                              {index !== toggle && (
                                                <CollapseDownIcon
                                                  key={index}
                                                  className={`w-5 h-5 text-gray-500`}
                                                  onClick={(e) => {
                                                    handleBundleProduct(
                                                      bundle?.bundleId,
                                                      index,
                                                      "show"
                                                    );
                                                  }}
                                                />
                                              )}

                                              {index === toggle && (
                                                <CollapseUpIcon
                                                  key={index}
                                                  className={`w-5 h-5 text-gray-500`}
                                                  onClick={(e) => {
                                                    handleBundleProduct(
                                                      bundle?.bundleId,
                                                      index,
                                                      "hide"
                                                    );
                                                  }}
                                                />
                                              )}
                                            </DisclosureButton>
                                          ) : (
                                            <DisclosureButton className="">
                                              {index !== toggle && (
                                                <CollapseDownIcon
                                                  key={index}
                                                  className={`w-5 h-5 text-purple-500 cursor-not-allowed`}
                                                />
                                              )}

                                              {index === toggle && (
                                                <CollapseUpIcon
                                                  key={index}
                                                  className={`w-5 h-5 text-purple-500 cursor-not-allowed`}
                                                />
                                              )}
                                            </DisclosureButton>
                                          )}
                                        </div>
                                        <div className="mt-2 ml-2">
                                          <Link
                                            className="cursor-pointer font-medium  text-indigo-600 hover:text-indigo-500 hover:underline"
                                            to={Constant.EDITBUNDLES.replace(
                                              ":id",
                                              bundle.bundleId.toString()
                                            )}
                                          >
                                            {bundle.bundleId}
                                          </Link>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                      <Link
                                        className="cursor-pointer font-medium  text-indigo-600 hover:text-indigo-500 hover:underline"
                                        to={Constant.EDITBUNDLES.replace(
                                          ":id",
                                          bundle.bundleId.toString()
                                        )}
                                      >
                                        {bundle.name}
                                      </Link>
                                    </td>
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                      {bundle.states &&
                                        bundle.states
                                          .map((state, i) => state.name)
                                          .join(", ")}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                      {bundle.isAlaCarte ? (
                                        <ApproveIcon></ApproveIcon>
                                      ) : (
                                        <Disapprove></Disapprove>
                                      )}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                      {bundle.salesforceLevel}
                                    </td>
                                    <td className="px-3 py-2   whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                      {bundle.totalProducts}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                      <div className="flex gap-3 justify-center">
                                        <AllowedTo
                                          perform={Permissions.bundle_modify}
                                        >
                                          <CopyIcon
                                            onClick={() =>
                                              handleCopyBundle(
                                                bundle.bundleId,
                                                bundle.name
                                              )
                                            }
                                            className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                          />

                                          <EditIcon
                                            onClick={() =>
                                              handleRedirect(bundle)
                                            }
                                            className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>

                                        <AllowedTo
                                          perform={Permissions.bundle_delete}
                                        >
                                          <DeleteIcon
                                            onClick={() =>
                                              handleBundleDelete(bundle)
                                            }
                                            className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                          />
                                        </AllowedTo>
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td colSpan={4} className="relative ">
                                      <div
                                        className={`${
                                          index !== toggle ? "hidden" : ""
                                        } pl-12 pr-12 px-4 pb-2 text-sm text-gray-500`}
                                      >
                                        <ActiveRowLine
                                          isActive={bundle.isActive}
                                        />
                                        <div className="shadow border-b rounded">
                                          <table className="min-w-full">
                                            <thead>
                                              <tr className="bg-gray-50 border">
                                                <th
                                                  scope="col"
                                                  className="gap-2 px-3 py-2 pl-6 font-semibold text-xs text-left text-gray-500 tracking-wider"
                                                >
                                                  <div className="flex items-center">
                                                    <span className="flex gap-2">
                                                      Product Id
                                                    </span>
                                                    <span className="cursor-pointer">
                                                      {sortByDesc &&
                                                      orderByColumn ===
                                                        "productId" ? (
                                                        <CaretUpSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretUpSolidIcon>
                                                      ) : (
                                                        <CaretDownSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretDownSolidIcon>
                                                      )}
                                                    </span>
                                                  </div>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                                >
                                                  <div className="flex items-center">
                                                    <span className="flex gap-2">
                                                      Name
                                                    </span>

                                                    <span className="cursor-pointer">
                                                      {sortByDesc &&
                                                      orderByColumn ===
                                                        "productId" ? (
                                                        <CaretUpSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretUpSolidIcon>
                                                      ) : (
                                                        <CaretDownSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretDownSolidIcon>
                                                      )}
                                                    </span>
                                                  </div>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                                >
                                                  <div className="flex items-center">
                                                    <span className="flex gap-2">
                                                      Content Area
                                                    </span>

                                                    <span className="cursor-pointer">
                                                      {sortByDesc &&
                                                      orderByColumn ===
                                                        "productId" ? (
                                                        <CaretUpSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretUpSolidIcon>
                                                      ) : (
                                                        <CaretDownSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretDownSolidIcon>
                                                      )}
                                                    </span>
                                                  </div>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 text-xs text-left text-gray-500 font-semibold tracking-wider"
                                                >
                                                  <div className="flex items-center">
                                                    <span className="flex gap-2">
                                                      Grade
                                                    </span>

                                                    <span className="cursor-pointer">
                                                      {sortByDesc &&
                                                      orderByColumn ===
                                                        "productId" ? (
                                                        <CaretUpSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretUpSolidIcon>
                                                      ) : (
                                                        <CaretDownSolidIcon
                                                          onClick={() =>
                                                            handleSortBy(
                                                              "productId"
                                                            )
                                                          }
                                                          className="w-4 h-4"
                                                        ></CaretDownSolidIcon>
                                                      )}
                                                    </span>
                                                  </div>
                                                </th>
                                                <th
                                                  scope="col"
                                                  className="px-3 py-2 pl-6 flex justify-center text-xs text-left text-gray-500 font-semibold tracking-wider"
                                                >
                                                  <span className="flex gap-2">
                                                    Active
                                                  </span>
                                                </th>

                                                <th
                                                  scope="col"
                                                  className="w-10 px-3 py-2 text-xs text-center text-gray-500 font-semibold tracking-wider"
                                                >
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="divide-y">
                                              {bundleProduct?.map(
                                                (product, index) => (
                                                  <tr
                                                    key={index}
                                                    className={"bg-white"}
                                                  >
                                                    <td
                                                      onClick={() =>
                                                        handleRedirectBundleProduct(
                                                          product
                                                        )
                                                      }
                                                    >
                                                      <Link
                                                        className="cursor-pointer font-medium pl-6 text-indigo-600 hover:text-indigo-500 hover:underline"
                                                        to={Constant.MANAGESELLABLEPRODUCT.replace(
                                                          ":id",
                                                          product.sellableProductId.toString()
                                                        )}
                                                      >
                                                        {
                                                          product.sellableProductId
                                                        }
                                                      </Link>
                                                    </td>
                                                    <td>
                                                      <Link
                                                        className="cursor-pointer font-medium pl-6 text-indigo-600 hover:text-indigo-500 hover:underline"
                                                        to={Constant.MANAGESELLABLEPRODUCT.replace(
                                                          ":id",
                                                          product.sellableProductId.toString()
                                                        )}
                                                      >
                                                        {product.name}
                                                      </Link>
                                                    </td>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                      {product.contentArea}
                                                    </td>
                                                    <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                      {product.grade}
                                                    </td>
                                                    <td className="px-3 py-2  text-sm text-center font-normal text-gray-500">
                                                      <div className="flex justify-center">
                                                        {product.isActive ? (
                                                          <ApproveIcon />
                                                        ) : (
                                                          <Disapprove />
                                                        )}
                                                      </div>
                                                    </td>
                                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-700">
                                                      <div className="flex gap-3 justify-center">
                                                        <AllowedTo
                                                          perform={
                                                            Permissions.bundle_modify
                                                          }
                                                        >
                                                          <EditIcon
                                                            onClick={() =>
                                                              handleRedirectBundleProduct(
                                                                product
                                                              )
                                                            }
                                                            className="w-4 text-xs font-light cursor-pointer hover:text-secondary-color transaction ease-in-out duration-300"
                                                          />
                                                        </AllowedTo>

                                                        <AllowedTo
                                                          perform={
                                                            Permissions.bundle_delete
                                                          }
                                                        >
                                                          <DeleteIcon
                                                            onClick={() =>
                                                              handleDeleteBundleProduct(
                                                                product
                                                              )
                                                            }
                                                            className="w-4 text-xs font-light cursor-pointer hover:text-red-500 transaction ease-in-out duration-300"
                                                          />
                                                        </AllowedTo>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                        {bundleProduct?.length === 0 && (
                                          <p className="p-2">
                                            No product added
                                          </p>
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </Disclosure>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-between items-center">
                  {bundles.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                        />
                      </span>
                    </>
                  ) : (
                    <p className="p-2">No Records Found</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};

export default connect(mapStateToProps, {})(Bundle);
